<script setup lang="ts">
import { useRouter } from 'vue-router';
import stores from '@ganaderia/stores';

const router = useRouter();

const logout = () => {
  router.push('/');
  stores.auth.funcs.logout();
  stores.app.state.showAppbar.value = false;
};
</script>

<template>
  <v-list nav class="py-0 pos-rel d-flex flex-column">
    <div class="d-flex justify-space-between mr-4 mb-4">
      <div></div>
      <div>Menu</div>
      <v-icon size="16" @click="stores.app.state.drawerOpen.value = false">mdi-close</v-icon>
    </div>
    <template v-if="stores.auth.state.user.value">
      <v-list-item class="list-item" to="/home">
        <template v-slot:prepend><v-icon>mdi-home</v-icon></template>
        <v-list-item-title>Elegir finca</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/cows-sold">
        <template v-slot:prepend><v-icon>mdi-currency-usd</v-icon></template>
        <v-list-item-title>Vacas vendidas</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/cows-dead">
        <template v-slot:prepend><v-icon>mdi-cloud</v-icon></template>
        <v-list-item-title>Vacas muertos</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/statistics">
        <template v-slot:prepend><v-icon>mdi-chart-bar</v-icon></template>
        <v-list-item-title>Statistica</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/agent" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-robot-outline</v-icon></template>
        <v-list-item-title>Agente</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/milk">
        <template v-slot:prepend><v-icon>mdi-cup-water</v-icon></template>
        <v-list-item-title>Leche</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/revisions" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-check-circle</v-icon></template>
        <v-list-item-title>Revisiones</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/history" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-history</v-icon></template>
        <v-list-item-title>Ultimos cambios</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/backups" v-if="stores.auth.state.user.value.can_write">
        <template v-slot:prepend><v-icon>mdi-download</v-icon></template>
        <v-list-item-title>Gurardar datos</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/upload" v-if="stores.auth.state.user.value.can_write" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-upload</v-icon></template>
        <v-list-item-title>Upload datos</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/syncs" v-if="stores.auth.state.user.value.can_write">
        <template v-slot:prepend><v-icon>mdi-sync</v-icon></template>
        <v-list-item-title>Syncs</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/settings" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-cog</v-icon></template>
        <v-list-item-title>Settings</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" @click="logout">
        <template v-slot:prepend><v-icon>mdi-logout</v-icon></template>
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
    </template>
    <template v-else>
      <v-list-item class="list-item" to="/">
        <template v-slot:prepend><v-icon>mdi-information</v-icon></template>
        <v-list-item-title>Info</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/login" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-account-circle</v-icon></template>
        <v-list-item-title>Login</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" to="/registrate" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-account-check</v-icon></template>
        <v-list-item-title>Registrate</v-list-item-title>
      </v-list-item>
      <v-list-item class="list-item" @click="stores.auth.funcs.loginLiveDemo().then(() => router.push('/home'))" :disabled="!stores.offline.state.online.value">
        <template v-slot:prepend><v-icon>mdi-television-play</v-icon></template>
        <v-list-item-title>Live Demo</v-list-item-title>
      </v-list-item>
    </template>

    <v-spacer></v-spacer>

    <v-list-item class="app-info d-flex flex-column align-baseline">
      <div v-if="stores.offline.state.online.value">Status: online <span class="circle green ml-1"></span></div>
      <div v-else>Status: offline <span class="circle orange ml-1"></span></div>
      <div>Syncs abiertas: {{ stores.offline.state.openSyncs.value }}</div>
      <div>Version: 1.0.1</div>
    </v-list-item>
  </v-list>
</template>

<style lang="scss" scoped>
.pos-rel {
  margin-top: 50px;
  min-height: 88vh;
}
.app-info {
  font-size: 10px;
  max-height: 50px !important;
  margin-bottom: 80px;
}
.circle {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.green {
  background-color: green;
}
.orange {
  background-color: orange;
}
.list-item {
  max-height: 20px;
}
</style>
